import React from 'react'

export function LegalReference() {
  return (
    <div
      className="mt-[1.2rem] max-w-[19rem] text-center text-[1.2rem]"
    >
      By continuing, you agree to our{' '}
      <a
        href="https://iact.com/legal/"
        target="_blank"
        rel="noreferrer"
      >
        terms of service and privacy policy
      </a>
      .
    </div>
  )
}
